import React from 'react'
import { MenuItem, TextField } from '@material-ui/core'
import { getYear } from 'date-fns'

export type YearPickerProps = {
  label?: string
  error?: string
  value: number
  onChange: (value: number) => void
  disabled?: boolean
}

export function YearPicker({
  label,
  error,
  value,
  onChange,
  disabled = false,
}: YearPickerProps): React.ReactElement {
  const currentYear = getYear(Date.now())

  // Allow selecting 25 years before and after current date.
  const years = new Array(50)
    .fill(0)
    .map((_, index) => currentYear - 25 + index)

  return (
    <TextField
      value={value}
      onChange={(event) => onChange(Number(event.target.value))}
      label={label}
      error={Boolean(error)}
      helperText={error}
      select
      disabled={disabled}
    >
      {years.map((year) => (
        <MenuItem key={year} value={year}>
          {year}
        </MenuItem>
      ))}
    </TextField>
  )
}
